export function classNames(...classes: unknown[]): string {
  return classes.filter(Boolean).join(' ')
}

/**
 * Formats bytes into a human-readable string
 */
export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Fetches the file size of an image
 * If width and height are provided, it will append them to the URL for more accurate sizing
 */
export async function getImageFileSize(url: string, width?: number | null, height?: number | null): Promise<number> {
  try {
    // Append dimensions to URL if provided and not null
    let sizedUrl = url;
    if (width !== null && height !== null && width && height) {
      // Determine if URL already has query parameters
      const separator = url.includes('?') ? '&' : '?';
      sizedUrl = `${url}${separator}w=${width}&h=${height}&fit=crop`;
    }
    
    // Print URL to console for debugging
    console.log(`Fetching size for: ${sizedUrl}`);
    
    const response = await fetch(sizedUrl, { method: 'HEAD' });
    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
    }
    
    const contentLength = response.headers.get('content-length');
    const size = contentLength ? parseInt(contentLength, 10) : 0;
    
    // Log the size for debugging
    console.log(`Size for ${sizedUrl}: ${size} bytes`);
    
    return size;
  } catch (error) {
    console.error('Error fetching file size:', error);
    return 0;
  }
}

/**
 * Calculates file size reduction percentage
 */
export function calculateReduction(originalSize: number, optimizedSize: number): number {
  if (originalSize === 0) return 0;
  return Math.round(((originalSize - optimizedSize) / originalSize) * 100);
}
